const navbar = {
  packages: "Paketai", // translated 
  hotelPackages: "Viešbučių paketai", // translated 
  experiences: "Patirtys", // translated 
  close: "Uždaryti", // translated 
  hotDeals: "Karštieji pasiūlymai", // translated 
  dashboard: "Prietaisų skydelis", // translated 
  pricing: "Kainodara", // translated 
};


export default navbar;
